(function($) {

    $(document).ready(function(){

        $('#share-property').click(function (e) {
            e.preventDefault();
            window.open( $(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            var target = this.hash,
                $target = $(target);

            $('html, body').animate({
                'scrollTop': $target.offset().top - 140
            }, 200, function () {
                //window.location.hash = target;
            });
        });

        /*
        $('.scroll-link').click(function (e) {
            e.preventDefault();
            let offset = 140; 
            let timing = 500; 
            var target = $(this.hash);

            var targetTop = target.offsetTop;

            console.log(targetTop);

            $('html, body').animate({
                scrollTop: ( targetTop - offset )
            }, timing);
        });
        */

    });
    
}(jQuery));
